import React, { ReactNode, useEffect, useState } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { useLocation } from 'react-router'

interface GoogleReCaptchaProviderProps {
  children: ReactNode
}

export const GoogleReCaptchaCustomProvider: React.FC<
  GoogleReCaptchaProviderProps
> = ({ children }) => {
  const [showCaptcha, setShowCaptcha] = useState(false)
  // const reCaptchaKey = process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY as string

  // show captcha on auth pages

  useEffect(() => {
    const isAuthPage = location.pathname.includes('/account')
    if (isAuthPage) {
      setShowCaptcha(true)
    } else {
      setShowCaptcha(false)
    }
  }, [location.pathname])

  if (!showCaptcha) {
    return children
  }

  return (
    <GoogleReCaptchaProvider
      // container={{
      //     element: "recaptcha-custom",
      //     parameters: {
      //         badge: 'inline'
      //     }
      // }}
      useEnterprise
      reCaptchaKey={'6LcoelQpAAAAAPjqH4FGtDk6C4ASxbWvEDi7BKqX'}
    >
      {children}
    </GoogleReCaptchaProvider>
  )
}
